module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_innlandet_neg.fbba7718.svg";